module.exports = __webpack_public_path__ + "img/logo_galp_costaluz.11ae2e9b.png";